<!-- =========================================================================================
    File Name: DuePortfolioSupplierStats.vue
    Description: Due Statistics Portfolio for supplier
    ----------------------------------------------------------------------------------------
========================================================================================== -->

<template>
    <vx-card v-if="allDataResponse.historicalSupplierDuePortfolio">
      <div class="vx-row">
        <div class="vx-col w-full">
          <vue-apex-charts v-if="!ignoreChart" type="area" height="350" :options="chartOptions" :series="chartSeries"></vue-apex-charts>
        </div>
      </div>
    </vx-card>    
</template>

<script>
import formatHelper from '@components/mixins/formatHelper';
import dateHelper from '@components/mixins/dateHelper';
import VueApexCharts from 'vue-apexcharts';

export default{
  name: 'historical-due-portfolio-supplier-stats',
  props: {
    supplierId: {
      type:[Number,String],
      required: true
    },
  },
  mixins: [formatHelper,dateHelper],
  components: {VueApexCharts},
  async mounted() {
    await this.getHistoricalSupplierDuePortfolio();
  },
  data () {
    return {
        allDataResponse: {
          historicalSupplierDuePortfolio:[],
          lastYear:[]
        },
        ignoreChart:false,
        chartSeries: [
            {
              name: "En proyectos",
              data: []
            },
            {
              name: "En saldo insoluto",
              data: []
            }
        ],
        chartOptions: {
            chart: {
              height: 350,
              type: 'area',
            },
            dataLabels: {
              enabled: false
            },
            xaxis: {
              categories: [],
            },
            fill: {
              opacity: 1,
            },
            yaxis: {
              min: 0,
              max: 100,
              labels: {
                formatter: (value) => { return value+"%" },
              },
            }
          }
    }
  },
  methods: {
    async getHistoricalSupplierDuePortfolio(){
        this.showLoading(true);
        let url = '/api/suppliers/getHistoricalDuePortfolioBySupplier/'+this.supplierId;
        await axios.get(url).then(response => {
            this.allDataResponse = response.data;
            this.allDataResponse.historicalSupplierDuePortfolio.forEach(element => {
              this.chartSeries[0].data.push(this.decimalPercentFormat(element["due_portfolio_number"]));
              this.chartSeries[1].data.push(this.decimalPercentFormat(element["due_portfolio_amount"]));              
            });
            this.chartOptions = {
              xaxis: {
                categories: this.allDataResponse.lastYear
              }
            };
            this.showLoading(false);
        }).catch(error => {
            this.showLoading(false);
        });
    },
  }
}
</script>
